import authHeader from './auth-header';
import Api from './api';

const API_URL = process.env.REACT_APP_AQUA_API_ENDPOINT

class QuestionFolderService {
	getHeaders() {
		var header = authHeader() as Record<string, string>;
		return header;
	}
	  
	async find(term: string, surveyType: number) {
		return await Api().get(`${API_URL}/questionFolder/find?text=${term}`, { headers:  this.getHeaders() as any });      
	}

	async createFolder(folder: any) {
		return await Api().post(`${API_URL}/questionFolder/`, folder, 
		{ method: 'POST',
		headers:  this.getHeaders() as any });      
	}

	async updateFolder(folder: any) {
		return await Api().put(`${API_URL}/questionFolder/${folder.id}`, folder, 
		{ method: 'PUT',
		headers:  this.getHeaders() as any });      
  	}

	async deleteFolder(folder: any) {
		return await Api().delete(`${API_URL}/questionFolder/${folder.id}`, 
		{ method: 'DELETE',
		headers:  this.getHeaders() as any });      
	}
}
export default new QuestionFolderService();